import {jsx} from 'panel';

import {ButtonEl} from 'common/components/button';
import {SelectTheme} from 'common/components/select/constants';
import {SelectEl} from 'common/components/select';
import {ButtonTheme} from 'common/components/button/constants';
import {TooltipAttrs} from 'common/components/tooltip/types';
import {SectionItem} from 'common/components/items-menu/types';
import {MenuChangeEvent} from 'common/components/select/types';

import {RowTypeComplexOption} from '../types';

export function AddEntryRow({
  hasContainedUI,
  hasPrefixRenderer,
  isDisabled,
  isOpen,
  tooltipAttrs,
  typeItems,
  addEntryButtonLabel,
  addEntryMenuWidth,
  onAddEntryRow,
  onAutofocusableElAdded,
  onAddTypeSelectMenuChange,
}: {
  hasContainedUI: boolean;
  hasPrefixRenderer: boolean;
  isDisabled: boolean;
  isOpen: boolean;
  tooltipAttrs: TooltipAttrs;
  typeItems: Array<SectionItem<RowTypeComplexOption['value']>>;
  addEntryButtonLabel: string;
  addEntryMenuWidth: number;
  onAddEntryRow: (type: string) => void;
  onAutofocusableElAdded: (elm: Node) => void;
  onAddTypeSelectMenuChange: (ev: MenuChangeEvent) => void;
}) {
  const singleEntryType = typeItems.length === 1 && typeItems[0].value;

  const buttonContents = (
    <>
      {singleEntryType ? (
        <ButtonEl
          attrs={{
            disabled: isDisabled,
            theme: ButtonTheme.Tertiary,
            icon: `plus`,
            elref: `newEntryButton`,
            tooltip: !isDisabled && tooltipAttrs,
          }}
          class={{
            'is-open': isOpen,
          }}
          on={{
            click: () => onAddEntryRow(singleEntryType),
          }}
          hook={{
            insert: ({elm}) => onAutofocusableElAdded(elm),
          }}
        >
          <span>{addEntryButtonLabel || `Add`}</span>
        </ButtonEl>
      ) : (
        <SelectEl
          attrs={{
            elref: `typeSelect`,
            disabled: isDisabled,
            icon: {leftIcon: `plus`, rightIcon: ``},
            'selected-option': addEntryButtonLabel || `Add`,
            'menu-width': addEntryMenuWidth,
            sections: [{items: typeItems}],
            theme: SelectTheme.Tertiary,
            tooltip: !isDisabled ? tooltipAttrs : null,
          }}
          class={{
            'is-open': isOpen,
          }}
          on={{
            change: (ev: CustomEvent) => onAddEntryRow(ev.detail.item.value),
            menuChange: onAddTypeSelectMenuChange,
          }}
          hook={{
            insert: ({elm}) => onAutofocusableElAdded(elm),
          }}
        />
      )}
    </>
  );

  // contained sections (inside mp-section for instance) render as
  // another row whereas the new UI will render a button row
  if (hasContainedUI) {
    return buttonContents;
  }

  return (
    <div
      sel='.mp-query-entry.is-add-row'
      key='new-entry'
      class={{
        'is-disabled': isDisabled,
        [`for-${singleEntryType}`]: Boolean(singleEntryType),
        'is-open': isOpen,
      }}
    >
      {/** include prefix spacing */}
      {hasPrefixRenderer && <div sel='.entry-selector-prefix' />}
      {buttonContents}
    </div>
  );
}
